import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'

import { List } from '../List'
const data = require('../../lib/data.json')

export function ListSection() {
  return (
    <div className='ui vertical segment'>
      <div className='ui centered cards'>
        {data.map(list => {
          return <List list={list} key={list.number} />
        })}
      </div>
    </div>
  )
}
